{
  "chooseBuilder": "Escoge tu builder",
  "Group": "Grupo",
  "changeAnytime": "Cambia en cualquier momento",
  "Track": "Sección"
}
